export const mainCls = 'modal-container';

export default {
    [mainCls]: {
        height: '100%',
    },
}